import cn from 'classnames';
import { memo, useEffect, useState } from 'react';
import styles from './countdown.module.scss';

export interface ICountdownTimerProps {
  seconds: number;
  start: boolean;
  onFinish?: () => void;
  className?: string;
  startingDate?: number;
}

const COUNTDOWN_STEP = 1;

const CountdownTimer = ({ seconds, start, onFinish, className = '' }: ICountdownTimerProps): JSX.Element => {
  const [countdown, setCountdown] = useState<number>(seconds);

  useEffect(() => {
    if (!start) return;

    const countdownInterval = setInterval(() => setCountdown((prevState) => prevState - COUNTDOWN_STEP), 1000);

    if (countdown <= 0) {
      clearInterval(countdownInterval);
      onFinish?.();
    }

    return () => clearInterval(countdownInterval);
  }, [countdown, start]);

  /* ClassNames */

  const secondsWrapperClasses = cn(styles.seconds__wrapper, {
    [styles.stop]: countdown <= 0 || !start,
  });

  return (
    <div className={cn(styles.countdown, className)}>
      <section className={styles.countdown__minutes}>
        <span>00</span>
      </section>
      <section className={styles.seconds}>
        <div className={secondsWrapperClasses}>
          <span>
            {countdown <= 9 && '0'}
            {countdown}
          </span>
        </div>
      </section>
    </div>
  );
};

export default memo(CountdownTimer);
